import { Chat } from "../components/Chat";
import { Hub } from "../components/Hub";


export const routes = [
    {
        route:'/',
        component:<Hub/>
    },

    {
        route:'/chat',
        component:<Chat/>
    }
]